"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;
var _react = _interopRequireDefault(require("react"));
var _styles = require("@material-ui/core/styles");
var _MobileStepper = _interopRequireDefault(require("@material-ui/core/MobileStepper"));
var _theme = require("../utils/theme");
var _Button = require("../Button");
var _styledComponents = require("styled-components");
var useStyles = (0, _styles.makeStyles)({
  root: {
    maxWidth: 850,
    flexGrow: 1,
    background: '#FFFFFF',
    marginTop: '8px'
  }
});
var Stepper = function Stepper(_ref) {
  var _ref$theme = _ref.theme,
    theme = _ref$theme === void 0 ? _theme.defaultTheme : _ref$theme,
    isNextStepDisabled = _ref.isNextStepDisabled,
    activeStep = _ref.activeStep,
    onNext = _ref.onNext,
    onBack = _ref.onBack,
    onComplete = _ref.onComplete,
    _ref$steps = _ref.steps,
    steps = _ref$steps === void 0 ? [] : _ref$steps,
    color = _ref.color;
  var classes = useStyles();
  return /*#__PURE__*/_react["default"].createElement(_styledComponents.ThemeProvider, {
    theme: theme
  }, steps[activeStep], /*#__PURE__*/_react["default"].createElement(_MobileStepper["default"], {
    variant: "dots",
    steps: steps.length,
    position: "static",
    activeStep: activeStep,
    className: classes.root,
    nextButton: /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      themeColor: (color !== null && color !== void 0 ? color : activeStep === steps.length - 1) ? theme.color.success : theme.color.primary,
      dense: true,
      icon: activeStep === steps.length - 1 ? 'checkmark' : 'arrow-right',
      onClick: activeStep === steps.length - 1 ? onComplete : onNext,
      disabled: isNextStepDisabled
    }, activeStep === steps.length - 1 ? 'Complete' : 'Next'),
    backButton: /*#__PURE__*/_react["default"].createElement(_Button.Button, {
      themeColor: color !== null && color !== void 0 ? color : theme.color.primary,
      type: "round",
      dense: true,
      icon: "arrow-left",
      disabled: activeStep === 0,
      onClick: onBack
    }, "Back")
  }));
};
var _default = exports["default"] = Stepper;